module.exports = "../images/fishing@2x.jpg?v=45185e2";